var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIGRTMAX = exports.getRealtimeSignals = void 0;

const getRealtimeSignals = function () {
  const length = SIGRTMAX - SIGRTMIN + 1;
  return Array.from({
    length
  }, getRealtimeSignal);
};

exports.getRealtimeSignals = getRealtimeSignals;

const getRealtimeSignal = function (value, index) {
  return {
    name: `SIGRT${index + 1}`,
    number: SIGRTMIN + index,
    action: "terminate",
    description: "Application-specific signal (realtime)",
    standard: "posix"
  };
};

const SIGRTMIN = 34;
const SIGRTMAX = 64;
exports.SIGRTMAX = SIGRTMAX; //# sourceMappingURL=realtime.js.map

export default exports;